import React, { useState } from "react";
import { IoIosSwitch } from "react-icons/io";
import { useSelector } from "react-redux";

const LowerThirdTemplatesModal = ({
  setShowLowerThirdModal,
  handleEffectSetting,
}) => {
  const [showPreview, setShowPreview] = useState("lt_animation_1.png");
  const overlayData = useSelector(
    (state) => state.personalize.personalize_overlayTemplateData
  );

  const handleClick = (e, type) => {
    handleEffectSetting(e, type);
    setShowLowerThirdModal(false);
  };

  const handleOver = (e, type) => {
    if (type === "lt_animation_1") {
      setShowPreview(type + ".png");
    } else {
      setShowPreview(type + ".png");
    }
  };
  return (
    <div
      className="modal fade show d-block"
      id="modalcreatevideo"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modalcreatevideoTitle"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered modal-xl"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3>Overlay Templates</h3>
            <button
              type="button"
              className="close"
              onClick={() => {
                setShowLowerThirdModal(false);
              }}
            >
              <i
                className="fas fa-times"
                style={{ fontSize: "20px", color: "#cacccf" }}
              ></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-4">
                <div className="list-container p-4">
                  <div className="list-group">
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "lt_animation_1"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "lt_animation_1"
                      )}
                      onClick={(e) => handleClick(e, "lt_animation_1")}
                      onMouseOver={(e) => handleOver(e, "lt_animation_1")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Template 1
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "lt_animation_2"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "lt_animation_2"
                      )}
                      onClick={(e) => handleClick(e, "lt_animation_2")}
                      onMouseOver={(e) => handleOver(e, "lt_animation_2")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Template 2
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "lt_animation_3"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "lt_animation_3"
                      )}
                      onClick={(e) => handleClick(e, "lt_animation_3")}
                      onMouseOver={(e) => handleOver(e, "lt_animation_3")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Template 3
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "lt_animation_4"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "lt_animation_4"
                      )}
                      onClick={(e) => handleClick(e, "lt_animation_4")}
                      onMouseOver={(e) => handleOver(e, "lt_animation_4")}
                    >
                      <IoIosSwitch size={24} className="text-info" />
                      Template 4
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "lt_animation_5"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "lt_animation_5"
                      )}
                      onClick={(e) => handleClick(e, "lt_animation_5")}
                      onMouseOver={(e) => handleOver(e, "lt_animation_5")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Template 5
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-8">
                <div className="display-container bg-light">
                  <div className="preview-template col-8 m-auto p-4">
                    <img
                      src={
                        "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/overlay_preview/" +
                        showPreview
                      }
                      className="img-fluid img-thumbnail mx-auto"
                      alt={`Preview ${showPreview}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LowerThirdTemplatesModal;
